import { Typography, Box, Button } from '@mui/material';
import CustomDialog from '../../Custom Components/CustomDialog/CustomDialog';
import { labels } from '../../../data/constants';
import { useNavigate } from 'react-router-dom';
const AccountCompleteModal = ({ showDialog, close }) => {
  const navigate = useNavigate();
  return (
    <CustomDialog handleOpen={showDialog} showClose={close}>
      <Typography textAlign={'center'} fontWeight={'bold'}>
        {labels.profile.completeProfileDialogTitle}
      </Typography>
      <Typography textAlign={'center'} mt={2}>
        {labels.profile.completeProfileDialogMsg}
      </Typography>
      <Box textAlign={'center'} mt={3}>
        <Button
          variant="buttonVariant1"
          onClick={() => {
            navigate('/account');
          }}
        >
          {labels.profile.goToAccount}
        </Button>
      </Box>
    </CustomDialog>
  );
};
export default AccountCompleteModal;
